import React, { FC } from 'react'
import { Alert } from 'antd'
import { NotaryAcknowledgementAlertsProps } from './types'

const NotaryAcknowledgementAlerts: FC<NotaryAcknowledgementAlertsProps> = ({ notaryAcknowledgement }) => {
  if (!notaryAcknowledgement) return null

  if (notaryAcknowledgement === 'will_correct') {
    return (
      <Alert
        message={<strong>You will correct these errors</strong>}
        description="Please upload the corrected documents as soon as possible."
        type="success"
        showIcon
        closable
        style={{ marginBottom: 12 }}
      />
    )
  }

  if (notaryAcknowledgement === 'request_clarification') {
    return (
      <Alert
        message={<strong>You need clarification</strong>}
        description="A Snapdocs team member will reach out to assist you."
        type="error"
        showIcon
        closable
        style={{ marginBottom: 12 }}
      />
    )
  }

  return null
}

export default NotaryAcknowledgementAlerts
